import React from 'react';
import { Switch } from '../ui/switch';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Settings } from 'lucide-react';

export function AdminSettingsSection({ 
    settings, 
    onSettingsChange, 
    onSaveSettings, 
    onToggleDemoMode 
}) {
    return (
        <div className="space-y-6" data-testid="admin-settings">
            <h2 className="text-2xl font-bold">App Settings</h2>
            
            <div className="card-base space-y-6">
                {/* Demo Mode */}
                <div className="flex items-center justify-between">
                    <div>
                        <Label className="text-base font-medium">Demo Mode</Label>
                        <p className="text-sm text-muted-foreground">
                            Enable demo features and skip real payments
                        </p>
                    </div>
                    <Switch 
                        checked={settings.demo_mode || false}
                        onCheckedChange={onToggleDemoMode}
                        data-testid="demo-mode-toggle"
                    />
                </div>

                <hr />

                {/* Featured Banner */}
                <div className="space-y-2">
                    <Label>Featured Banner Text</Label>
                    <Input
                        value={settings.featured_banner_text || ''}
                        onChange={(e) => onSettingsChange({ ...settings, featured_banner_text: e.target.value })}
                        placeholder="Welcome message or announcement..."
                        data-testid="featured-banner-input"
                    />
                </div>

                {/* Cafe Special */}
                <div className="space-y-2">
                    <Label>Café Special Text</Label>
                    <Input
                        value={settings.cafe_special_text || ''}
                        onChange={(e) => onSettingsChange({ ...settings, cafe_special_text: e.target.value })}
                        placeholder="Today's special..."
                        data-testid="cafe-special-input"
                    />
                </div>

                {/* Cafe Opening Times */}
                <div className="space-y-2">
                    <Label>Café Opening Times</Label>
                    <Input
                        value={settings.cafe_opening_times || ''}
                        onChange={(e) => onSettingsChange({ ...settings, cafe_opening_times: e.target.value })}
                        placeholder="Mon-Sat: 9am-5pm, Sun: 10am-4pm"
                        data-testid="cafe-hours-input"
                    />
                </div>

                <hr />

                {/* Membership Pricing */}
                <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                        <Label>Membership Price (£/year)</Label>
                        <Input
                            type="number"
                            value={settings.membership_price || 995}
                            onChange={(e) => onSettingsChange({ ...settings, membership_price: parseInt(e.target.value) })}
                            data-testid="membership-price-input"
                        />
                    </div>
                    <div className="space-y-2">
                        <Label>Annual Credits</Label>
                        <Input
                            type="number"
                            value={settings.annual_credits || 30}
                            onChange={(e) => onSettingsChange({ ...settings, annual_credits: parseInt(e.target.value) })}
                            data-testid="annual-credits-input"
                        />
                    </div>
                </div>

                <Button onClick={onSaveSettings} className="w-full" data-testid="save-settings-btn">
                    <Settings className="w-4 h-4 mr-2" />
                    Save Settings
                </Button>
            </div>
        </div>
    );
}
